module.exports = __webpack_public_path__ + "static/media/0024.c51eb7f5.jpg";